import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function CallDetailPage() {
  const { t } = useTranslation(['pages', 'common']);
  const navigate = useNavigate();
  const { callId } = useParams<{ callId: string }>();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!callId) return;
    const params = new URLSearchParams(searchParams);
    params.set('call', callId);
    const queryString = params.toString();
    navigate(`/calls${queryString ? `?${queryString}` : ''}`, { replace: true });
  }, [callId, navigate, searchParams]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
        px: 3,
      }}
    >
      <CircularProgress />
      <Typography variant="body1" color="text.secondary" textAlign="center">
        {t(
          'pages:calls.detail.redirecting',
          'Redirecionando você para a lista de chamadas...',
        )}
      </Typography>
    </Box>
  );
}
